import NoDefaultMealPlanView from './NoDefaultMealPlanView';

export default NoDefaultMealPlanView;
